import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgInstagramOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M10.72 3q.765-.002 1.532.016l.136.005.498.021c.745.035 1.253.153 1.699.326.462.177.851.418 1.24.807.356.35.632.773.807 1.24.173.446.29.955.326 1.7.008.186.015.341.02.498l.005.136q.02.765.016 1.531v1.439q.004.767-.015 1.533l-.004.135-.021.499c-.035.745-.154 1.253-.327 1.699-.175.467-.45.89-.807 1.24-.35.356-.773.631-1.24.807-.446.173-.954.29-1.699.326-.187.008-.341.015-.498.02l-.136.005q-.766.019-1.532.016H9.28q-.765.003-1.532-.015l-.136-.005-.498-.02c-.745-.036-1.253-.155-1.7-.327a3.4 3.4 0 0 1-1.24-.807 3.4 3.4 0 0 1-.807-1.24c-.173-.446-.29-.954-.326-1.7l-.02-.498-.004-.135A55 55 0 0 1 3 10.719V9.28q-.002-.765.016-1.531l.005-.136c.005-.157.012-.312.02-.498.036-.746.153-1.253.326-1.7.176-.467.452-.89.81-1.239.349-.356.771-.632 1.238-.808.447-.173.954-.29 1.7-.326l.498-.02.136-.004q.765-.02 1.532-.018zM10 6.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7m0 1.4a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2m3.675-2.45a.875.875 0 0 0 0 1.75.875.875 0 1 0 0-1.75"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInstagramOutlined);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
